import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParametersComponent } from './parameters/parameters.component';

import { TableModule } from '../../components/table/table.module';
import { MatIconModule } from '@angular/material/icon';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { ParametersViewComponent } from './parameters-view/parameters-view.component';
import { MatTableModule } from '@angular/material/table';


@NgModule({
  declarations: [
    ParametersComponent,
    ParametersViewComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TableModule,
    MatAccordion,
    MatExpansionModule,
    MatFormFieldModule,

    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatTableModule,
  ],
  exports:[
    ParametersComponent
  ]
})
export class ParametersModule { }
